if (document.querySelectorAll('[data-component="slick"]').length > 0) {
    
    document.addEventListener('DOMContentLoaded', function () {
        let promoSlider = $('.slider--promo');
        let programSlider = $('.slider--program');
        let clientSlider = $('.slider--client');

        promoSlider.slick({
            autoplay: true,
            autoplaySpeed: 7000,
            arrows: true,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

        function historyBack() {
            setTimeout(function () {
                promoSlider.slick("slickGoTo", 0);
            }, 3000);
        };

        promoSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            // console.log(currentSlide);

            // if (currentSlide === 2) {
            //     historyBack();
            // }
        });

        programSlider.slick({
            arrows: true,
            dots: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1024,
                settings: 'unslick'
            }]
        });

        clientSlider.slick({
            autoplay: true,
            autoplaySpeed: 7000,
            arrows: false,
            dots: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1920,
                settings: {
                    slidesToShow: 4,
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                }
            }]
        });
    })
}